var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_325_316446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26658 25.5917C6.24447 23.8176 6.24447 21.6334 7.26658 19.8592L12.6511 10.513C13.676 8.73387 15.573 7.63749 17.6262 7.63749L28.3738 7.63749C30.427 7.63749 32.324 8.73387 33.3489 10.513L38.7334 19.8592C39.7555 21.6334 39.7555 23.8176 38.7334 25.5917L33.3489 34.938C32.324 36.7171 30.427 37.8135 28.3738 37.8135L17.6262 37.8135C15.573 37.8135 13.676 36.7171 12.6511 34.938L7.26658 25.5917Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_325_316446)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4753 13.9565C23.4051 13.9927 23.3102 14.0797 23.2644 14.15L23.1811 14.2777V18.1479C23.1811 22.3915 23.167 22.1173 23.3951 22.2928C23.4912 22.3667 23.5577 22.3682 27.2645 22.3779C31.4616 22.3889 31.2031 22.4042 31.3656 22.1348C31.4385 22.0138 31.4428 21.9726 31.4197 21.6061C31.3594 20.6515 31.0428 19.5129 30.5676 18.5421C29.9261 17.2317 28.83 15.9987 27.5998 15.2038C26.5374 14.5173 25.3859 14.1013 24.1165 13.9454C23.575 13.8789 23.6279 13.878 23.4753 13.9565ZM21.1086 14.6242C19.3146 14.883 17.763 15.649 16.47 16.9141C14.2061 19.1293 13.3597 22.3698 14.236 25.4668C14.6113 26.7927 15.3311 28.0277 16.3204 29.0427C17.6182 30.3741 19.199 31.1876 21.0353 31.4689C21.606 31.5563 22.694 31.5563 23.2912 31.4687C24.8376 31.2421 26.1468 30.6652 27.3727 29.67C27.6976 29.4063 27.7499 29.343 27.8042 29.149C27.8807 28.8756 27.9363 28.9395 25.014 25.9393C23.4817 24.3663 22.2506 23.073 22.2292 23.014C22.2033 22.9427 22.1907 21.6182 22.1907 18.9539C22.1906 15.2636 22.1863 14.9911 22.1265 14.8708C21.9835 14.5834 21.7625 14.5298 21.1086 14.6242ZM25.4297 23.5547C25.32 23.6107 25.254 23.6791 25.2005 23.7926C25.1158 23.9718 25.1079 24.0635 25.1638 24.217C25.2074 24.3367 29.8576 29.129 30.0111 29.2125C30.1466 29.2861 30.4048 29.28 30.5223 29.2003C30.5754 29.1643 30.7251 28.9994 30.855 28.834C31.8739 27.5362 32.4847 26.0235 32.6481 24.3929C32.7012 23.8635 32.678 23.7609 32.4681 23.5969L32.3388 23.4958L28.9613 23.486C25.5995 23.4763 25.583 23.4766 25.4297 23.5547Z",
    fill: "url(#paint0_linear_325_316446)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_325_316446)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4296 23.5546C25.3198 23.6105 25.2539 23.6789 25.2003 23.7924C25.1157 23.9716 25.1077 24.0634 25.1636 24.2168C25.2072 24.3365 29.8575 29.1288 30.011 29.2123C30.1465 29.286 30.4046 29.2798 30.5221 29.2001C30.5752 29.1641 30.725 28.9992 30.8548 28.8338C31.8738 27.536 32.4845 26.0233 32.648 24.3927C32.701 23.8633 32.6779 23.7608 32.468 23.5967L32.3386 23.4956L28.9611 23.4858C25.5993 23.4761 25.5829 23.4764 25.4296 23.5546Z",
    fill: "url(#paint1_linear_325_316446)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_325_316446",
    x: 4.36364,
    y: 5.76838,
    width: 39.142,
    height: 38.9882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.934656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_325_316446"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.934656,
    dy: 3.87214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_325_316446",
    result: "effect2_dropShadow_325_316446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_325_316446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_325_316446",
    x: 0.525795,
    y: 0.525795,
    width: 47.7926,
    height: 46.6549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.13793,
    dy: 1.13793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.25431
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.831373 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_325_316446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_325_316446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_325_316446",
    x: 11.7572,
    y: 10.1108,
    width: 36.5612,
    height: 34.7995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.13793,
    dy: 1.13793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.25431
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.831373 0 0 0 0 0.443137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_325_316446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_325_316446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_325_316446",
    x1: 15.3663,
    y1: 18.6846,
    x2: 17.101,
    y2: 24.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_325_316446",
    x1: 31.4851,
    y1: 28.9493,
    x2: 29.1833,
    y2: 22.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181A19",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424523,
    stopColor: "#595959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0B0",
    stopOpacity: 0.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMenuIcon);
export default __webpack_public_path__ + "static/media/product-menu-icon.80e70d5a1473aeb7dfd4d6239cd20c4a.svg";
export { ForwardRef as ReactComponent };